import { render, staticRenderFns } from "./BasePromptConfirmation.vue?vue&type=template&id=6a906ebb&"
import script from "./BasePromptConfirmation.vue?vue&type=script&lang=ts&"
export * from "./BasePromptConfirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports